export const MenuSize = 48;
